module.exports = __webpack_public_path__ + "static/media/fa.87de1e68.svg";